<template>
  <div>
    <!-- <div id="content" class="colM">
      <h1>{{ $t("registration.password_reset_set_pass_title") }}</h1>
      <p>{{ $t("registration.password_reset_set_pass_content") }}</p>
      <form role="form" method="post" @submit.prevent="passwodResetSetPassword">
        <div class="box-body">
          <div class="form-group">
            <div class="input-group" style="width:100%;">
              <label for="exampleInputEmail1">{{
                $t("registration.password_reset_set_pass_btn1")
              }}</label>
              <input
                style="width:100%;"
                @input="validatePassword(password1)"
                type="password"
                class="form-control"
                v-model="password1"
              />
              <span
                :class="{
                  password_length_count: valid_password_length,
                  show_password_length: password_typed
                }"
                class="password_length_modal"
                style="z-index:999"
                >{{ password_length }}</span
              >
            </div>
            <div v-show="password_typed" class="lnu_container">
              <p :class="{ got_lowercase: contain_lowercase }">
                {{ $t("user.password_modal[0].lowercase") }}
              </p>
              <p :class="{ got_number: contain_number }">
                {{ $t("user.password_modal[0].digit") }}
              </p>
              <p :class="{ got_uppercase: contain_uppercase }">
                {{ $t("user.password_modal[0].uppercase") }}
              </p>
            </div>
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">{{
              $t("registration.password_reset_set_pass_btn2")
            }}</label>
            <input type="password" class="form-control" v-model="password2" />
          </div>
        </div>
        <div class="box-footer">
          <button type="submit" class="btn btn-primary">
            {{ $t("registration.password_reset_set_pass_btn3") }}
          </button>
        </div>
      </form>
      <br class="clear" />
    </div> -->
    <div>
      <div class="">
        <h2
          class="heading-w3-agile"
          style="text-align:center; color:black; font-weight: 200; text-transform: uppercase;"
        >
          {{ $t("registration.password_reset_set_pass_title") }}
        </h2>
        <p class="heading-w3-agile" style="margin-bottom: 15px;">
          {{ $t("registration.password_reset_set_pass_content") }}
        </p>
        <form
          role="form"
          method="post"
          @submit.prevent="passwodResetSetPassword"
        >
          <div class="inputs-w3ls">
            <p style="color:black;">
              {{ $t("registration.password_reset_set_pass_btn1") }}:
            </p>
            <i
              class="fa fa-envelope"
              aria-hidden="true"
              :style="password_typed ? 'bottom: 53px;' : ''"
            ></i>
            <input
              type="password"
              class="email"
              name="Email"
              :placeholder="$t('registration.password_reset_set_pass_btn1')"
              @input="validatePassword(password1)"
              required=""
              v-model="password1"
            />
            <span
              :class="{
                password_length_count: valid_password_length,
                show_password_length: password_typed
              }"
              class="password_length_modal"
              style="z-index:999"
              >{{ password_length }}</span
            >
            <div v-show="password_typed" class="lnu_container">
              <p :class="{ got_lowercase: contain_lowercase }">
                {{ $t("user.password_modal[0].lowercase") }}
              </p>
              <p :class="{ got_number: contain_number }">
                {{ $t("user.password_modal[0].digit") }}
              </p>
              <p :class="{ got_uppercase: contain_uppercase }">
                {{ $t("user.password_modal[0].uppercase") }}
              </p>
            </div>
          </div>
          <div class="inputs-w3ls">
            <p style="color:black;">
              {{ $t("registration.password_reset_set_pass_btn2") }}:
            </p>
            <i class="fa fa-envelope" aria-hidden="true"></i>
            <input
              type="password"
              :placeholder="$t('registration.password_reset_set_pass_btn2')"
              required=""
              v-model="password2"
            />
          </div>
          <label class="anim">
            <!-- <a @click="cancelPasswodReset" style="color:black; cursor: pointer;">{{
              $t("common.callBackLogin")
            }}</a> -->
          </label>
          <input type="submit" :value="$t('registration.reset_btn')" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import utils from '@/lib/utils'

export default {
  name: "PasswordResetSetPassword",
  data() {
    return {
      uidb64: null,
      token: null,
      password1: null,
      password2: null,
      password_typed: false,
      contain_lowercase: false,
      contain_uppercase: false,
      contain_number: false,
      password_length: 0,
      valid_password_length: false,
      valid_password: false
    };
  },
  computed: {
    ...mapGetters([])
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ACCOUNT_PASSWORD_RESET_SET_PASSWORD",
      "ON_SHOW_TOAST"
    ]),
    passwodResetSetPassword: function() {
      if (!this.valid_password) {
        this.ON_SHOW_TOAST({
          message: "Vui lòng nhập đúng định dạng mật khẩu",
          styleType: "danger"
        });
      } else if (this.password1 !== this.password2) {
        this.ON_SHOW_TOAST({
          message: "Mật khẩu cũ và mật khẩu mới không khớp.",
          styleType: "danger"
        });
      } else {
        let payload = {
          uidb64: this.uidb64,
          token: this.token,
          password1: this.password1,
          password2: this.password2
        };
        this.ACCOUNT_PASSWORD_RESET_SET_PASSWORD(payload)
          .then(
            function() {
              this.SUCCESS_TOAST();
              this.$router.push({ name: "Login" });
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    validatePassword: function(password) {
      this.password_length = password.length;
      if (this.password_length > 7) {
        this.valid_password_length = true;
      } else {
        this.valid_password_length = false;
      }
      if (this.password_length > 0) {
        this.password_typed = true;
      } else {
        this.password_typed = false;
      }
      this.contain_lowercase = /[a-z]/.test(password);
      this.contain_uppercase = /[A-Z]/.test(password);
      this.contain_number = /\d/.test(password);
      if (
        this.contain_lowercase == true &&
        this.contain_uppercase == true &&
        this.contain_number == true &&
        this.valid_password_length == true
      ) {
        this.valid_password = true;
      } else {
        this.valid_password = false;
      }
    }
  },
  components: {},
  mounted() {
    let body = document.getElementsByTagName("BODY")[0];
    body.className = "login-page hold-transition";
    this.uidb64 = this.$route.params.uidb64;
    this.token = this.$route.params.token;
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/login_style.css";
@import "font-awesome/css/font-awesome.min.css";
h1 {
  margin: 0 0 20px;
  font-weight: 300;
  font-size: 20px;
  color: #666;
}
.lnu_container {
  display: block;
  margin: 2px auto;
  margin-bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}
.lnu_container p {
  width: 30%;
  height: auto;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  border-radius: 2px;
  color: rgba(71, 87, 98, 0.8);
  background: linear-gradient(to right, #06a65a 50%, #eee 50%);
  background-size: 200% 100%;
  background-position: right;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
}
.show_password_length {
  display: inline-block !important ;
}
.password_length {
  padding: 2px 8px;
  position: absolute;
  top: 42px;
  right: 22px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.password_length_modal {
  padding: 2px 8px;
  position: absolute;
  top: 41.3%;
  right: 5px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.password_length_count {
  background: #06a65a;
  color: rgba(255, 255, 255, 0.9);
}
.got_lowercase,
.got_uppercase,
.got_number {
  background-position: left !important;
  color: rgba(255, 255, 255, 0.9) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Account/PasswordResetSetPassword.vue